<template>
    <b-row class="no-gutters">
        <b-col cols="6" md="3" v-for="(item, id) in game.items" :key="id" @click="select(id)" class="item p-1">
            <b-button
                :pressed="isSelected(id)"
                variant="outline-success"
                class="w-100">
                <div class="text-left mb-3 possible">
                    <div class="checked">
                        <fa-icon icon="check"></fa-icon>
                    </div>
                    <div class="text-muted">{{ 'purchase.possible_win' | lang }}</div>
                    <fa-icon class="text-warning" icon="trophy"></fa-icon>
                    <b>{{ amount * item.multiplier | currency }}</b>
                </div>
                <div class="d-flex odds">
                    <div class="odd" v-for="odd in game.odds[item.symbol]" :key="odd">
                        <fa-icon icon="clone"></fa-icon>
                        <span>{{ odd }}</span>
                    </div>
                </div>
                <span class="symbol">{{ item.symbol }}</span>
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";
import { groupBy } from "lodash";

export default {
    props: ['gameId', 'selectedItems'],

    computed: {
        ...mapState(['selection']),

        game() {
            return Config.games[this.gameId];
        },

        amount() {
            if(!this.selection) {
                return;
            }

            return this.game.amounts[this.selection.amountId].amount;
        },
    },

    methods: {
        select(id) {
            this.$emit('select', { id })
        },

        isSelected(id) {
            return this.selectedItems.includes(id);
        },
    },
}
</script>